import relaxImage from './assets/peace.png';
import focusImage from './assets/dark.png';
import activeImage from './assets/deachoo.png';
import creativeImage from './assets/original.png';

export const quizData = {
  questions: [
    {
      id: 1,
      text: '업무나 공부 중 갑작스러운 스트레스를 받았을 때, 당신의 첫 반응은?',
      answers: [
        { text: '일단 하던 일을 멈추고 심호흡을 한다', type: 'relax' },
        { text: '문제가 무엇인지 끝까지 파헤쳐 해결하려 한다', type: 'focus' },
        { text: '주변 사람들에게 상황을 이야기하고 감정을 털어놓는다', type: 'active' },
        { text: '잠시 다른 생각을 하며 머리를 식힌다', type: 'creative' },
      ],
    },
    {
      id: 2,
      text: '완벽한 휴일을 보낼 수 있다면, 당신이 선택할 장소는?',
      answers: [
        { text: '조용한 숲속이나 파도 소리가 들리는 바닷가', type: 'relax' },
        { text: '자기계발을 할 수 있는 서점이나 강연장', type: 'focus' },
        { text: '사람들이 북적이는 핫플레이스나 축제 현장', type: 'active' },
        { text: '영감을 얻을 수 있는 이색적인 전시회나 미술관', type: 'creative' },
      ],
    },
    {
      id: 3,
      text: '에너지가 완전히 고갈되었을 때(번아웃), 당신을 다시 일으키는 것은?',
      answers: [
        { text: '충분한 수면과 정적인 명상', type: 'relax' },
        { text: '작은 목표를 달성했을 때의 성취감', type: 'focus' },
        { text: '친구들과의 즐거운 대화와 웃음', type: 'active' },
        { text: '새로운 취미 활동이나 창작 활동', type: 'creative' },
      ],
    },
    {
      id: 4,
      text: '당신이 선호하는 스트레스 해소 음식은?',
      answers: [
        { text: '따뜻한 차나 마음을 안정시키는 부드러운 음식', type: 'relax' },
        { text: '잠이 확 깨는 진한 커피나 다크 초콜릿', type: 'focus' },
        { text: '땀이 뻘뻘 나는 매운 음식이나 자극적인 음식', type: 'active' },
        { text: '한 번도 먹어보지 못한 이국적인 요리', type: 'creative' },
      ],
    },
    {
      id: 5,
      text: '주변 사람들에게 당신은 어떤 사람으로 보이나요?',
      answers: [
        { text: '함께 있으면 마음이 편안해지는 안정적인 사람', type: 'relax' },
        { text: '목표가 뚜렷하고 배울 점이 많은 스마트한 사람', type: 'focus' },
        { text: '어딜 가나 분위기를 주도하는 에너자이저 같은 사람', type: 'active' },
        { text: '창의적이고 독특한 관점을 가진 아이디어 뱅크', type: 'creative' },
      ],
    },
    {
      id: 6,
      text: '가장 선호하는 운동 스타일은?',
      answers: [
        { text: '요가나 필라테스 같은 정적인 운동', type: 'relax' },
        { text: '헬스나 달리기 같은 목표 지향적 운동', type: 'focus' },
        { text: '테니스나 축구 같은 팀 스포츠', type: 'active' },
        { text: '댄스나 수영처럼 리듬감 있는 운동', type: 'creative' },
      ],
    },
    {
      id: 7,
      text: '자기 전 주로 하는 행동은?',
      answers: [
        { text: '내일을 위한 명상이나 일기 쓰기', type: 'relax' },
        { text: '오늘 성과를 복기하고 내일 계획 세우기', type: 'focus' },
        { text: 'SNS를 보며 트렌드나 지인 소식 확인하기', type: 'active' },
        { text: '상상의 나래를 펼치거나 영감을 주는 영상 보기', type: 'creative' },
      ],
    },
    {
      id: 8,
      text: '갈등 상황이 생겼을 때 당신의 대처법은?',
      answers: [
        { text: '상대방의 입장을 먼저 생각하고 조율한다', type: 'relax' },
        { text: '논리적으로 잘잘못을 가리고 해결책을 찾는다', type: 'focus' },
        { text: '감정을 솔직하게 표현하고 대화로 푼다', type: 'active' },
        { text: '유머나 제3의 대안으로 분위기를 전환한다', type: 'creative' },
      ],
    },
    {
      id: 9,
      text: '당신을 가장 설레게 하는 단어는?',
      answers: [
        { text: '평온 (Peace)', type: 'relax' },
        { text: '성장 (Growth)', type: 'focus' },
        { text: '열정 (Passion)', type: 'active' },
        { text: '자유 (Freedom)', type: 'creative' },
      ],
    },
    {
      id: 10,
      text: '미래의 자신에게 해주고 싶은 말은?',
      answers: [
        { text: '천천히 가도 괜찮아, 지금처럼 평온하길', type: 'relax' },
        { text: '결국 해냈구나! 네 노력이 빛을 발했어', type: 'focus' },
        { text: '인생을 정말 멋지게 즐겼구나!', type: 'active' },
        { text: '너만의 색깔을 잃지 않고 살았구나', type: 'creative' },
      ],
    },
  ],
  results: {
    relax: {
      name: '평온한 숲속의 명상가 유형',
      description:
        '당신은 내면의 평화를 중요하게 생각하며, 정적인 환경에서 에너지를 얻는 사람입니다. 스트레스를 받을 때 외부로 표출하기보다 스스로 갈무리하며 안정을 찾는 능력이 뛰어납니다. 주변 사람들에게는 따뜻한 위로와 편안함을 주는 존재입니다. 하지만 가끔은 혼자 너무 많은 생각을 하느라 결단력이 부족해질 때가 있으니, 가벼운 산책이나 외부 활동으로 기분 전환을 해주는 것이 좋습니다.',
      imageUrl: relaxImage,
    },
    focus: {
      name: '목표 지향적인 전략가 유형',
      description:
        '당신은 명확한 목표와 논리적인 사고를 통해 삶의 질을 높이는 사람입니다. 스트레스를 성장의 발판으로 삼으며, 문제를 해결했을 때 가장 큰 희열을 느낍니다. 자기관리가 철저하고 시간 관리에 능숙하여 주변의 신뢰를 한 몸에 받습니다. 다만, 스스로에게 너무 엄격하여 번아웃이 올 수 있으니 가끔은 "아무것도 하지 않는 시간"을 의도적으로 갖는 연습이 필요합니다.',
      imageUrl: focusImage,
    },
    active: {
      name: '에너지 넘치는 활동가 유형',
      description:
        '당신은 사람들과 교류하고 열정적으로 움직일 때 최고의 컨디션을 유지하는 사람입니다. 스트레스를 대화와 웃음으로 날려버리는 긍정적인 에너지를 가졌습니다. 새로운 트렌드에 민감하고 적응력이 빨라 어떤 환경에서도 환영받는 리더 스타일입니다. 하지만 에너지를 외부로만 쏟다 보면 정작 자신의 내면을 돌보는 시간을 놓칠 수 있으니, 하루 10분이라도 온전히 자신에게 집중하는 시간을 가져보세요.',
      imageUrl: creativeImage,
    },
    creative: {
      name: '자유로운 영혼의 예술가 유형',
      description:
        '당신은 틀에 박힌 일상보다 새로운 영감과 창의적인 활동에서 행복을 찾는 사람입니다. 독특한 관점으로 세상을 바라보며, 스트레스 상황에서도 위트 있는 해결책을 찾아내곤 합니다. 당신만의 개성은 사람들에게 신선한 자극을 줍니다. 때로는 현실적인 문제들을 챙기는 것이 버거울 수 있지만, 당신의 상상력은 우리 사회를 더욱 다채롭게 만드는 소중한 자산입니다.',
      imageUrl: activeImage,
    },
  },
};

